import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import FilteringDataDisplay from '../FilteringDataDisplay.vue'
import { useStoreProfiles } from '../../store/useStoreProfiles'
import { computed, ref, shallowRef, watchEffect } from 'vue'
import { useFilteringDisplayOptions } from '../../composables/useFilteringDisplayOptions'
import { useOrders } from '../../store/useOrders'
import FormOrderItem from '../FormOrderItem.vue'
import { Table } from 'app/types/components/data-rendering'

export default /*#__PURE__*/_defineComponent({
  __name: 'StorePicklist',
  props: {
    storeId: {},
    isFetching: { type: Boolean }
  },
  setup(__props: any) {

const props = __props
//picklist
const loading = ref(true)
const pickListData = shallowRef<Table>({ data: [], meta: { columns: {} } })

watchEffect(
  async () => {
    //tasks
    const { getPickListData } = useStoreProfiles()
    pickListData.value = getPickListData(props.storeId)
    loading.value = false
  },
  { flush: 'post' }
)
const pickListReasonCodes = [
  { name: 'neverReceivedOriginal' },
  { name: 'receivedPartialShipment' },
  { name: 'receivedIncorrectMaterials' },
  { name: 'materialsReceivedDamaged' },
  { name: 'other' },
]
const { pickListDisplayOptions, pickListClickedRow, openOrderModal } = useFilteringDisplayOptions({
  isFetching: props.isFetching,
})
const ordersHeaders = computed((): { header: string; subheaders: [string, string] } => {
  return {
    header: 'Add Item to Order',
    subheaders: [pickListClickedRow.value?.artwork_id, pickListClickedRow.value?.description],
  }
})
//todo move order modal to wrapper component
const { addOrder } = useOrders()
const addOrderItem = (e: any) => {
  addOrder({
    artwork_id: e.data.artwork_id,
    quantity: e.quantity,
    reason: e.reason,
    comment: e.comment,
    date: e.date,
  })
}

return (_ctx: any,_cache: any) => {
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_dialog, {
      modelValue: _unref(openOrderModal),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(openOrderModal) ? (openOrderModal).value = $event : null))
    }, {
      default: _withCtx(() => [
        (_unref(pickListClickedRow))
          ? (_openBlock(), _createBlock(FormOrderItem, {
              key: 0,
              headers: ordersHeaders.value,
              data: _unref(pickListClickedRow),
              "reason-options": pickListReasonCodes,
              onAction: addOrderItem,
              "render-order": ['quantity', 'reason', 'comment']
            }, null, 8, ["headers", "data"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_openBlock(), _createBlock(FilteringDataDisplay, {
      key: `${_ctx.storeId}-${loading.value}-picklist`,
      "is-loading": loading.value,
      "table-data": pickListData.value,
      options: _unref(pickListDisplayOptions),
      "enable-filters": true
    }, null, 8, ["is-loading", "table-data", "options"]))
  ], 64))
}
}

})